export default function (props: any) {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h76v76H0z" />
                <g transform="translate(23 10)">
                    <rect stroke="#979797" strokeWidth="2" width="31" height="56" rx="4" />
                    <path stroke="#979797" strokeWidth="2" strokeLinecap="round" d="M11 51.5h9" />
                    <path d="M8 1h16-1a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1V2a1 1 0 0 0-1-1H8z" fill="#979797" />
                </g>
            </g>
        </svg>
    );
}
